<template>
  <div class="main-container">
    <h1>404</h1>
    <div>Page Not Found</div>
  </div>
</template>

<script>
export default {
  name: "PageNotFound"
}
</script>

<style scoped>
  * {
    line-height: 1;
  }

  .main-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /*height: 100vh;*/
  }

  h1 {
    font-size: 4.5em;
  }
</style>